import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

import ModalTask from 'components/Organisms/Modals/ModalTask/ModalTask';
import QuestionBasic from 'components/Organisms/QuestionBasic/QuestionBasic';
import leafPng from 'assets/images/leaf.png';
import calendarPng from 'assets/images/calendar.png';
import CardSomeoneElse from 'components/Atoms/Cards/CardSomeoneElse/CardSomeoneElse';
import { findTaskRules } from '../../RulesTaskCards.constanst';
import { ModuleKeys } from 'services/task/modules-keys.constanst';
import { Task, TaskResponse, TaskState } from 'gql/graphql';
import StateTag from 'components/Atoms/Tags/StateTag/StateTag';
import { useGetTaskResponsesByTask } from 'services/task/querys';
import { useCreateResponseTask } from 'services/task/mutations';
import SectionSuccessTask from 'scenes/Private/components/SectionSuccessTask/SectionSuccessTask';
import ModalFinish from './ModalFinish';
import { useGetUserLoggin } from '../../../../../services/user/querys';
import { UpdateDashboardContext } from '../../Dashboard';
import ModalEndSubmit from 'components/Organisms/Modals/ModalEndSubmit/ModalEndSubmit';
import { TaskOpenModalContext } from 'scenes/Private/Private';

interface PropertyAccessDetailsProps {
  task: Task;
}

const PropertyAccessDetails = ({ task }: PropertyAccessDetailsProps) => {

  const { value: openContext, setHandler }: any = useContext(TaskOpenModalContext);
  const { setValue: setUpdateDashboard }: any = useContext(UpdateDashboardContext);

  const { data: user } = useGetUserLoggin();
  const { execute: createResponseTask } = useCreateResponseTask();
  const { data: taskResponses, reexecute: getTaskResponses } = useGetTaskResponsesByTask({
    variables: { findResponsesByTask: { taskId: task._id } }
  });

  const [isReview, setIsReview] = useState(false);
  const [response, setResponse] = useState<TaskResponse>();
  const [isModalTaskVisible, setModalTaskVisible] = useState(false);
  const [isModalFinish, setModalFinish] = useState(false);
  const [isModalConfirmMe, setIsModalConfirmMe] = useState(false);

  useEffect(() => {
    if (openContext === 'property_access' || openContext === ModuleKeys.PROPERTY_ACCESS) {
      setModalTaskVisible(true);
      setHandler();
    } else if (!!openContext)
      setModalTaskVisible(false);
  }, [openContext]);

  //Si la tarea no ha sido aprobada y no hay respuestas, se muestra el modal
  useEffect(() => {
    const automaticOpenModalPropertyAccess = localStorage.getItem('automaticOpenModalPropertyAccess');

    if (task?.state !== TaskState.Approved && taskResponses?.length === 0 && !automaticOpenModalPropertyAccess) {
      localStorage.setItem('automaticOpenModalPropertyAccess', 'true');
      setModalTaskVisible(true);
    }

    setIsReview(task?.state === TaskState.Review);
  }, [task, taskResponses])

  useEffect(() => {
    const _response: any = taskResponses?.find((item) => item.step === 1);
    setResponse(_response);
  }, [taskResponses]);

  const onHelpDocs = () => {
    console.log('onHelpDocs');
  };

  const onSubmit = async (option: any, metadata?: any) => {
    if (option.id === 1) {
      setIsModalConfirmMe(true);
      return;
    }
    if (!response) {
      await createResponseTask({
        key: option.id === 1 ? 'me' : 'someone-else',
        label: 'Who will be coordinating access for appraisers and other vendors?',
        step: 1,
        metadata: metadata || {},
        state: TaskState.Approved,
        task: task?._id
      });
      setUpdateDashboard(true);
      getTaskResponses({ requestPolicy: 'network-only' });
      setModalFinish(true);
    }
  };

  const handleSubmitMe = async () => {
    setIsModalConfirmMe(false);
    if (!response) {
      await createResponseTask({
        key: 'me',
        label: 'Who will be coordinating access for appraisers and other vendors?',
        step: 1,
        metadata: {},
        state: TaskState.Approved,
        task: task?._id
      });
      setUpdateDashboard(true);
      getTaskResponses({ requestPolicy: 'network-only' });
      setModalFinish(true);
    }
  };


  const renderTracker = () => (
    <div style={{ height: '100%' }}>
      <span className='title-summary'>Task summary</span>
      <div className='mt-20'>
        <span className='description'>
          The main contact for the property is{' '}

          <span>{
            response && (
              response?.key === 'me' ?
                (user?.name + ' ' + user?.lastName) :
                (response?.metadata?.name + ' ' + response?.metadata?.lastName)
            )
          }</span>
        </span>
      </div>
    </div>
  );

  const { taskName, phase } = findTaskRules(ModuleKeys.PROPERTY_ACCESS);

  return (
    <ModalTask
      visible={isModalTaskVisible}
      handlerSetVisibile={setModalTaskVisible}
      responses={[{ ...task, step: 1 }]}
      renderButtonTrigger={(openModal: any) => (
        <Button
          className={`button-open-modal button-open-modal-${task.state}`}
          onClick={() => openModal(true)}
        >
          {(task.state === TaskState.Review || task.state === TaskState.Approved) ? 'View task' :
            (task.state === TaskState.Incomplete) ? 'Complete task' :
              (task.state === TaskState.RequestError) ? 'Resolve issues' :
                'Begin Task'
          }
        </Button>
      )}
      header={{
        title: <span>{taskName.toUpperCase()}</span>,
        actionLeft: isReview ? <StateTag state={TaskState.Review} size="large" /> : <img src={leafPng} alt="icon" className="paperPng" />,
        actionRight: (
          <Button
            className="button button-transparent"
            onClick={() => onHelpDocs()}
          >
            <QuestionCircleOutlined />
            Help docs
          </Button>
        )
      }}
      animationDirection="onRight"
      stepsTotal={1}
      currentStep={1}
      setStep={() => { }}
      tracker={renderTracker()}
    >
      <div className="children property-access-detail">
        <h2 className="h3">
          Welcome, {user?.name}! We need a few things to get you approved for your loan.
        </h2>

        {task?.state === TaskState.Approved &&
          <SectionSuccessTask
            title="You've completed this task."
            button={{ title: "Back to dashboard", onClick: () => setModalTaskVisible(false) }}
          />
        }

        <div className="mt-50">
          <QuestionBasic
            question={
              <h3 className="h2">
                Who will be coordinating access for appraisers and other
                vendors?
              </h3>
            }
            disabled={task.state === TaskState.Review || task.state === TaskState.Approved}
            type="dropdown"
            options={[
              {
                id: 1,
                title: 'Me',
                onClick: onSubmit,
              },
              {
                id: 2,
                title: 'Someone else',
                dropdown: (metadata: any) => (
                  <CardSomeoneElse handlerSubmit={onSubmit} response={response} />
                ),
                styleHover: 'option-hover-blue',
                styleActive: 'option-active-blue',
                onClick: () => { }
              }
            ]}
            optionSelected={response?.key === 'someone-else' ? 2 : 1}
          />
        </div>
        {isModalConfirmMe && (
          <ModalEndSubmit
            visible={isModalConfirmMe}
            setVisible={setIsModalConfirmMe}
            buttonAction={{
              hidden: true
            }}
            modal={{
              title: 'Ready to submit?',
              description: (
                <h4 className="h4 h4-w4">{`After submitting, you’ll have to contact us if you want to make
              changes to the property access details`}</h4>
              )
            }}
            buttonSubmit={
              <Button htmlType='submit' className="button button-modal-ok" onClick={handleSubmitMe}>
                Yes, this is correct
              </Button>
            }
            buttonCancel={
              <Button className="button button-modal-cancel" onClick={() => setIsModalConfirmMe(false)}>
                I want to make changes
              </Button>
            }
            icon={calendarPng}
            className="modal-end-submit--white"
          />
        )}
        <ModalFinish
          visible={isModalFinish}
          setVisible={setModalFinish}
          closeTask={() => setModalTaskVisible(false)}
        />
      </div>
    </ModalTask>
  );
};
export default PropertyAccessDetails;
